export default __webpack_public_path__ + "static/media/Netflix.dfd97c9c.jpg";